module.exports = __webpack_public_path__ + "fonts/ade91f4.ttf";